/**
 * Pagination component
 */

// React
import React, { FC } from 'react';

// Material
import Pagination from '@mui/material/Pagination';
import { SxProps } from '@mui/material/styles';

// Utils
import { MIN_ITEMS_ON_PAGE, ParamsGetListSetting } from 'utils/constants';

// Interface
interface PaginationComponentProps {
  dataLength: number;
  totalPages: number;
  currentPage: number;
  handleChangePage: (_event: React.ChangeEvent<unknown>, _page: number) => void;
  sx?: SxProps;
}

// Component
const PaginationComponent: FC<PaginationComponentProps> = ({
  dataLength,
  totalPages,
  currentPage,
  handleChangePage,
  sx = { mt: '20px', userSelect: 'none' },
}) => {
  const lastFirstPerPage = ParamsGetListSetting.LAST_FIRST_PER_PAGE;
  if (dataLength <= MIN_ITEMS_ON_PAGE) return null;

  return (
    <Pagination
      sx={sx}
      count={totalPages}
      page={currentPage}
      color="secondary"
      onChange={handleChangePage}
      variant="outlined"
      shape="rounded"
      showFirstButton={totalPages > lastFirstPerPage}
      showLastButton={totalPages > lastFirstPerPage}
      siblingCount={0}
      boundaryCount={1}
    />
  );
};

export default PaginationComponent;
